export const DEZSR_V1ResourcesDE: DEZSR_V1ResourcesBSInterface = {
  labelDone: "Datum der Aufgabenerledigung",
  errors: {
    registerPic: "Das Bild, das Sie hochladen, ist zu groß.",
    recordAlreadyExists:
      "Diese Evidenz wurde bereits ausgefüllt. Sie können sie nicht erneut ausfüllen.",
  },
  input: {
    naziv: {
      label: "Name *",
      key: "naziv",
      placeholder: "Bitte geben Sie den Namen ein",
      error: "Bitte geben Sie den Namen ein",
    },
    primjena: {
      label: "Anwendung",
      key: "primjena",
      placeholder: "Bitte geben Sie die Anwendung ein",
    },
    upustvoZaUpotrebu: {
      label: "Gebrauchsanweisung",
      key: "upustvoZaUpotrebu",
      placeholder: "Bitte geben Sie ein, wie es angewendet wird",
    },
    vrsta: {
      label: "Art",
      key: "vrsta",
      placeholder: "Produktart nach Herstellererklärung",
    },
    slika: {
      label: "Bild",
      name: "slika",
      error: "Bitte wählen Sie Ihr Bild aus",
      validation: "Falsches Bild",
      description: () => (
        <>
          <h4>Dateien hier ablegen oder zum Hochladen klicken.</h4>
          <span className="text-muted font-13">Nur Bilder, max 6MB</span>
        </>
      ),
      key: "",
      placeholder: "",
    },
  },
  evidencijaForm: {
    buttonForward: "Unterschreiben",
    buttonBack: "Zurück",
  },
  successModal: {
    title: "Dateneingabe",
    body: "Das Hinzufügen von Daten wurde erfolgreich abgeschlossen. Wählen Sie OK zum Fortfahren.",
    buttonOk: "OK",
  },
  txtPotvrda:
    "Durch die Auswahl der Option Unterschreiben bestätige ich, dass die Aufgabe gemäß den Anweisungen ausgeführt wurde!",
  errorMissingInput: "Bitte füllen Sie alle Felder aus",
};

interface InputField {
  label: string;
  key: string;
  placeholder: string;
  name?: string;
  error?: string;
  validation?: string;
  description?: () => JSX.Element;
}

interface Input {
  naziv: InputField;
  primjena: InputField;
  upustvoZaUpotrebu: InputField;
  vrsta: InputField;
  slika: InputField;
}

interface EvidencijaForm {
  buttonForward: string;
  buttonBack: string;
}

interface SuccessModal {
  title: string;
  body: string;
  buttonOk: string;
}

interface IErrors {
  registerPic: string;
  recordAlreadyExists: string;
}

export interface DEZSR_V1ResourcesBSInterface {
  labelDone: string;
  input: Input;
  evidencijaForm: EvidencijaForm;
  successModal: SuccessModal;
  txtPotvrda: string;
  errorMissingInput: string;
  errors: IErrors;
}
